export const GRAPHQL_VARIABLES = {
  record: {
    status: 'requested'
  },
  filter: {
    _id: '5fc44f4e84ffd06759c1a1f6'
  }
};

export const QUERY = `
  mutation billsUpdateOne ($record: UpdateOnebillsInput!, $filter: AutoFilledFilterUpdateOnebillsInput!, $sort: SortUpdateOnebillsInput, $skip: Int) {
    billsUpdateOne (record: $record, filter: $filter, sort: $sort, skip: $skip) {
        recordId
        record {
            companyId
            invoiceId
            vendorId
            status
            allowedPaymentTypes
            currency
            total
            paid
            amountDue
            amountPaid
            metadata
            _id
            updatedAt
            createdAt
        }
        error {
            message
        }
    }
  }
`;
